import styled from '@emotion/styled';
import { Text } from '$shared/components/Text/Text';

export const StyledLoadContainer = styled.div(({ theme }) => ({
    marginTop: theme.spaces[5],
    paddingTop: theme.spaces[6],
    paddingBottom: theme.spaces[6],
    textAlign: 'center',
    flex: '1',
    width: '100%',
}));

export const StyledText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spaces[3],
}));
